// extracted by mini-css-extract-plugin
export default {"activeOrders":"Gkw7a","table":"btfT5"};